import type { CSSProperties } from "react";
import { cn } from "@link/ui";
import type { SpaceRole } from "../lib/api";

export type NameRole = Pick<SpaceRole, "color" | "name_style" | "secondary_color">;

export function RoleName({ name, role, className }: {
  name: string;
  role?: NameRole | undefined;
  className?: string;
}) {
  const style = role === undefined ? undefined : {
    color: role.color,
    "--role-primary": role.color,
    "--role-secondary": role.secondary_color ?? role.color,
  } as CSSProperties;
  return <span style={style} data-role-style={role?.name_style ?? "solid"}
    className={cn("role-name truncate", className)}>{name}</span>;
}
